export default "__VITE_ASSET__Ufgrg4A___"